export default "__VITE_ASSET__BnMOPrry__"